import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SuperbuySpreadsheetGuide from "../pages/article/superbuy-spreadsheet-guide/page";
import ArticleWhatIs from "../pages/article/what-is-superbuy-spreadsheet/page";
import ArticleBestDeals from "../pages/article/best-superbuy-spreadsheet-deals/page";
import ArticleSafety from "../pages/article/superbuy-spreadsheet-safety/page";
import ArticleTopBrands from "../pages/article/top-brands-superbuy-spreadsheet/page";
import ArticleHowToOrder from "../pages/article/how-to-order-superbuy-spreadsheet/page";
import ArticleShipping from "../pages/article/superbuy-spreadsheet-shipping/page";
import ArticleSneakers from "../pages/article/sneaker-buying-superbuy-spreadsheet/page";
import ArticleStreetwear from "../pages/article/streetwear-superbuy-spreadsheet/page";
import ArticleMistakes from "../pages/article/superbuy-spreadsheet-mistakes/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/article/what-is-superbuy-spreadsheet",
    element: <ArticleWhatIs />,
  },
  {
    path: "/article/best-superbuy-spreadsheet-deals",
    element: <ArticleBestDeals />,
  },
  {
    path: "/article/superbuy-spreadsheet-safety",
    element: <ArticleSafety />,
  },
  {
    path: "/article/top-brands-superbuy-spreadsheet",
    element: <ArticleTopBrands />,
  },
  {
    path: "/article/how-to-order-superbuy-spreadsheet",
    element: <ArticleHowToOrder />,
  },
  {
    path: "/article/superbuy-spreadsheet-shipping",
    element: <ArticleShipping />,
  },
  {
    path: "/article/sneaker-buying-superbuy-spreadsheet",
    element: <ArticleSneakers />,
  },
  {
    path: "/article/streetwear-superbuy-spreadsheet",
    element: <ArticleStreetwear />,
  },
  {
    path: "/article/superbuy-spreadsheet-mistakes",
    element: <ArticleMistakes />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;